export const LEASING_SELECTOR_RADIO_GROUP_NAME = 'leasing-selector-radio-group';
